'use client'

import { createContext, useContext, type ReactNode } from 'react'

import type { IndexingPolicy } from '@/lib/seo/indexing-policy'

// A missing snapshot is not evidence that ordinary destinations are noindexed.
// Public locale pages supply the full policy; standalone tools retain authored
// relationships except for private routes that bypass public redirects.
const IndexingContext = createContext<IndexingPolicy | null>(null)

export const IndexingProvider = ({ policy, children }: { policy: IndexingPolicy; children: ReactNode }) => (
  <IndexingContext.Provider value={policy}>{children}</IndexingContext.Provider>
)

export const useIndexingPolicy = () => useContext(IndexingContext)
